/**
 * Generates the Google Shopping Agent (GECX) loader URL.
 *
 * @param {string} [id] - The merchant GECX ID.
 * @param {string} [gecxFeatures] - feature flags for GECX.
 * @returns {string} The formatted loader URL or empty string.
 */
export const getGecxLoaderUrl = (id, gecxFeatures = '') => {
  if (!id) {
    return '';
  }
  return `https://agents.cloud.google.com/shopping_agent/loader.js?${gecxFeatures}merchantId=${encodeURIComponent(id)}`;
};
